module.exports = __webpack_public_path__ + "img/youshang.e1f1414e.png";